module.exports = __webpack_public_path__ + "static/media/oleg_mild_right.eadb3eb5.png";